export default __webpack_public_path__ + "static/media/bg-slider-home.a087f4a4.jpg";